import React from 'react';
import { Box, List, ListItem } from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';
import { v1 } from 'uuid';
import { getPhoneNumberNormalized } from 'utils';
import { StyledListItem, StyledListItemIcon, StyledListItemText } from '../styles';
var CustomerListItemPhones = function (_a) {
    var phones = _a.phones;
    return (React.createElement(StyledListItem, null,
        React.createElement(StyledListItemIcon, null,
            React.createElement(PhoneIcon, null)),
        React.createElement(Box, { columnGap: 2, component: List, display: "grid", gridTemplateColumns: "1fr 1fr", p: 0, width: "100%" }, phones.map(function (_a) {
            var phoneNumber = _a.phoneNumber;
            return phoneNumber ? (React.createElement(Box, { key: v1(), component: ListItem, p: 0 },
                React.createElement(StyledListItemText, { primary: getPhoneNumberNormalized(phoneNumber) }))) : null;
        }))));
};
export default CustomerListItemPhones;
//# sourceMappingURL=CustomerListItemPhones.js.map